<div class="row">
  <div class="col-md-4"><label>{{title}}</label></div>
  <div class="col-md-8">
    <div class="form-group">

      <!-- <ngx-form-column-select *ngIf="mode === 'column-select'" title="Add finished product:" [textfield]="true" (productSelected)="productSelected($event)">
      </ngx-form-column-select>
 -->
      <ngx-document-finished-product-selector *ngIf="mode === 'column-select'" [multiselect]="multiple" [businessId]="businessId" (compilationChange)="productSelected($event)"></ngx-document-finished-product-selector>

      <div *ngIf="mode === 'cs-select'" class="row">
        <div class="col-md-3">Add grouped shipment:</div>
        <div class="col-md-9">
          <ngx-document-cs-selector
            title="Add grouped shipment"
            [abstractItem]="combinedShipment"
            [mode]="2"
            [multiselect]="multiple"
            [latestVersionItems]="$any(options)"
            (compilationChange)="addSelection($event.code)"
          ></ngx-document-cs-selector>
        </div>
      </div>

      <ng-select *ngIf="!checkbox" [multiple]="multiple" [(ngModel)]="value" (change)="updateValue($event)" [placeholder]="placeholder || title">
        <ng-option *ngFor="let option of options" [value]="option.id">{{option.name}}</ng-option>
      </ng-select> 

      <!-- <ng-select *ngIf="checkbox" [multiple]="multiple" [(ngModel)]="value" (change)="updateValue($event)" 
        [items]="options" bindValue="id" bindLabel="name">
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.name}}
        </ng-template>
      </ng-select> -->

      <ng-select *ngIf="checkbox"
          [items]="options"
          bindValue="id"
          bindLabel="name"
          [multiple]="true"
          [closeOnSelect]="false"
          [placeholder]="placeholder || title"
          [ngModel]="value"
          (ngModelChange)="updateValue($event)">
          <!-- <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.gender | uppercase}}
          </ng-template> -->
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.name}}
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <table>
                <tr>
                  <td class="pl-1">
                      <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/>
                  </td>
                  <td class="pl-2">
                      <div *ngFor="let line of getLines(item.name)">{{line}}</div>
                  </td>
                </tr>
            </table>
          </ng-template>
      </ng-select>

    </div>
  </div>
</div>
